export enum Reportv2Tab {
  SUMMARY = 'report/summary',
  TICKET = 'report/ticket',
  AGENT = 'report/agent',
  CUSTOMER = 'report/customer',
  HISTORY = 'report/history',
  CUSTOM = 'report/customs',
  GROUP = 'report/group',
  AGENTV1 = 'report/agentv1',
}
export const Reportv2TabList = [
  {
    id: Reportv2Tab.SUMMARY,
    icon: 'fa fa-bar-chart',
    title: 'Tổng quan',
  },
  {
    id: Reportv2Tab.TICKET,
    icon: 'fa fa-ticket',
    title: 'Báo cáo ticket',
  },
  {
    id: Reportv2Tab.AGENT,
    icon: 'fa fa-user',
    title: 'Báo cáo Agent',
  },

  {
    id: Reportv2Tab.GROUP,
    icon: 'fa fa-building',
    title: 'Báo cáo phòng ban',
  },
  {
    id: Reportv2Tab.CUSTOMER,
    icon: 'fa fa-users',
    title: 'Báo cáo khách hàng',
  },
  {
    id: Reportv2Tab.HISTORY,
    icon: 'fa fa-phone',
    title: 'Lịch sử cuộc gọi',
  },

  {
    id: Reportv2Tab.CUSTOM,
    icon: 'fa fa-cog',
    title: 'Báo cáo tùy chỉnh',
  },
];

export const Reportv2TabListAgent = [
  {
    id: Reportv2Tab.SUMMARY,
    icon: 'fa fa-bar-chart',
    title: 'Tổng quan',
  },
  {
    id: Reportv2Tab.HISTORY,
    icon: 'fa fa-phone',
    title: 'Lịch sử cuộc gọi',
  },
];

export function getCurrentTab(url) {
  let tab = '';
  Object.keys(Reportv2Tab).forEach(s => {
    if (url.includes(Reportv2Tab[s])) {
      tab = Reportv2Tab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/reportv2.const.ts